import { formatMsShort, formatMsShortNoHours } from '../../../../../../../shared/frontend/libs/utils';

export function TimeStyling(props: any) {
  const formattedTime = props.includeHours
    ? formatMsShort(props.timeMs, props.precision)
    : formatMsShortNoHours(props.timeMs, props.precision);
  const parts = formattedTime.split('.', 2);
  if (parts.length === 1) {
    return <div>{parts}</div>;
  }
  return (
    <div>
      {parts[0]}
      <span className="text-muted--slight">.{parts[1]}</span>
    </div>
  );
}
